import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const currentDate = new Date(dayjs(new Date()).format("MM/DD/YYYY"));

const initialState = {
  filterScreen: {
    branchList: [],
    branchValue: null,
    applicationArray: [],
    applicationNum: null,
    emiStartDate: currentDate,
    lastDisbDate: currentDate,
    loanClosureDate: null,
    sanctionedDate: currentDate,
    customerName: null,
    customerId: null,
    loanStatus: null,
    sanctionAmt: 0,
    totalOsAmt: "",
    mandateStatus: "",
    pricipleOs: "",
    priciple: "",
    emiOs: "",
    receiptAmt: "",
    simpleInterest: "",
    prePayCharge: "",
    incidentPenal: "",
    memoModelList: [],
    memoModelTotal: {
      paidTotal: "",
      dueTotal: "",
      waiverTotal: "",
      osTotal: "",
    },
    createdBy: "",
    lastModifiedBy: "",
  },

  touchHandler: {
    branchTouched: false,
    applicationNumTouched: false,
  },

  valueIsValid: {
    branchIsValid: false,
    applicationNumIsValid: false,
  },
};
const LoanClosureReducer = createSlice({
  name: "loanClosure",
  initialState: initialState,
  reducers: {
    updateBranchList(state, action) {
      state.filterScreen.branchList = action.payload;
    },
    updateBranchValue(state, action) {
      state.filterScreen.branchValue = action.payload;
      state.valueIsValid.branchIsValid =
        action.payload !== "" && action.payload !== null;
    },
    updateApplicationArray(state, action) {
      state.filterScreen.applicationArray = action.payload;
    },

    updateMandateStatus(state) {
      state.filterScreen.mandateStatus = "InActive";
    },

    updateUsers(state, action) {
      state.filterScreen.createdBy = action.payload;
      state.filterScreen.lastModifiedBy = action.payload;
    },

    updateApplicationValue(state, action) {
      state.filterScreen.applicationNum = action.payload;
      state.valueIsValid.applicationNumIsValid =
        action.payload !== "" && action.payload !== null;
    },

    //Reducer for touch handler
    updateBranchIsTouched(state, action) {
      state.touchHandler.branchTouched = action.payload;
    },
    updateApplicationNumberIsTouched(state, action) {
      state.touchHandler.applicationNumTouched = action.payload;
    },

    resetfilterScreen(state, action) {
      state.filterScreen.branch = null;
      state.filterScreen.branchValue = null;
      state.filterScreen.applicationArray = [];
      state.filterScreen.applicationNum = null;
      state.filterScreen.customerName = "";
      state.filterScreen.customerId = "";
      state.filterScreen.loanStatus = "";
      state.filterScreen.sanctionAmt = 0;
      state.filterScreen.totalOsAmt = "";
      state.filterScreen.mandateStatus = "";
      state.filterScreen.emiStartDate = currentDate;
      state.filterScreen.lastDisbDate = currentDate;
      state.filterScreen.loanClosureDate = null;
      state.filterScreen.sanctionedDate = currentDate;
    },

    resetfilterScreenForFetchValues(state, action) {
      state.filterScreen.customerName = "";
      state.filterScreen.customerId = "";
      state.filterScreen.loanStatus = "";
      state.filterScreen.sanctionAmt = 0;
      state.filterScreen.totalOsAmt = "";
      state.filterScreen.mandateStatus = "";
      state.filterScreen.emiStartDate = currentDate;
      state.filterScreen.lastDisbDate = currentDate;
      state.filterScreen.loanClosureDate = null;
      state.filterScreen.sanctionedDate = currentDate;
    },

    updatefilterScreen(state, action) {
      state.filterScreen.branch = action.payload.branch.label;
      state.filterScreen.applicationNum = action.payload.applicationNum;
      state.filterScreen.customerName = action.payload.customerName;
      state.filterScreen.customerId = action.payload.customerId;
      state.filterScreen.loanStatus = action.payload.loanStatus;
      state.filterScreen.sanctionAmt = action.payload.sanctionAmt;
      state.filterScreen.totalOsAmt = action.payload.totalOsAmt;
      state.filterScreen.mandateStatus = action.payload.mandateStatus;
      state.filterScreen.emiStartDate = action.payload.emiStartDate;
      state.filterScreen.lastDisbDate = action.payload.lastDisbDate;
      state.filterScreen.loanClosureDate = action.payload.loanClosureDate;
      state.filterScreen.sanctionedDate = action.payload.sanctionedDate;
    },

    updateLoanClosureData(state, action) {
      state.filterScreen.pricipleOs = action.payload.pricipleOs;
      state.filterScreen.priciple = action.payload.priciple;
      state.filterScreen.emiOs = action.payload.emiOs;
      state.filterScreen.receiptAmt = action.payload.receiptAmt;
      state.filterScreen.simpleInterest = action.payload.simpleInterest;
      state.filterScreen.prePayCharge = action.payload.prePayCharge;
      state.filterScreen.incidentPenal = action.payload.incidentPenal;
      state.filterScreen.memoModelList = action.payload.memoModelList;
      state.filterScreen.memoModelTotal = action.payload.memoModelTotal;
    },

    resetLoanClosureData(state, action) {
      state.filterScreen.pricipleOs = "";
      state.filterScreen.priciple = "";
      state.filterScreen.emiOs = "";
      state.filterScreen.receiptAmt = "";
      state.filterScreen.simpleInterest = "";
      state.filterScreen.prePayCharge = "";
      state.filterScreen.incidentPenal = "";
      state.filterScreen.memoModelList = [];
      state.filterScreen.memoModelTotal = {
        paidTotal: "",
        dueTotal: "",
        waiverTotal: "",
        osTotal: "",
      };
    },

    resetAllTouchHandlers(state, action) {
      state.touchHandler = initialState.touchHandler;
      // since all gets reset so reset the valueIsValid also.
      state.valueIsValid = initialState.valueIsValid;
    },
  },
});
export const LoanClosureReducerAction = LoanClosureReducer.actions;
export default LoanClosureReducer.reducer;
